export default __webpack_public_path__ + "static/media/sign-in-background.a5d3b35e.svg";